import { Box, InputAdornment, Button, Stack, Divider } from "@mui/material";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import BSSForm from "../../../form/BSSForm";
import BSSText from "../../../form/BSSText";
import { DefaultSubmitErrorHandler } from "../../../preventivo/Preventivo";
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from "../../../../lib/traduzioni";
import { BSSDialogWithActions} from "../../../form/BSSDialog";
import BSSNumber from "../../../form/BSSNumber";
import { mappaOperatoriComparazione } from "./FiltriOrdini";
const {logger} = useBSSLogger();

const DialogFiltroTotale = ({filtri, setFiltri, dialogFiltroTotale, setDialogFiltroTotale}) => {

    const methods = useForm({
        defaultValues: {operatore: "eq", totaleordine: 0.00}
    })

    const {handleSubmit} = methods;


    const onSubmit = (data) => {
        const {totaleordine, operatore} = data
        logger.debug("ricarico gli ordini submit filtro totale", data)
        setFiltri({
            ...filtri, 
            filtriRicerca: {
                ...filtri.filtriRicerca,
                totaleordine: totaleordine,
                operatore
            }, 
            skip: 0
        });        
        methods.reset();
        setDialogFiltroTotale({mostra: false})
    }

    const rules = {required: __t("validazione.requiredField", [__t("totale")])}

    return (
        <BSSDialogWithActions
            title={__t("filtrapertotale")}                                                        
            open={dialogFiltroTotale.mostra} 
            closeHandler={e => setDialogFiltroTotale({mostra: false})} 
            sx={{"& .MuiDialogContent-root": {p: 0}}}
        >
            <FormProvider {...methods}>
                <BSSForm onEnterSubmit onSubmit={handleSubmit(onSubmit, DefaultSubmitErrorHandler)}>                  
                    <Stack>
                        <Box p={2}>
                            <BSSNumber
                                name={`totaleordine`} 
                                label={__t("totale")}    
                                methods={methods}          
                                NumberFormatProps={{
                                    decimalScale: 2,
                                    InputProps: {
                                        sx: {
                                            paddingRight: 0
                                        },
                                        startAdornment: (
                                            <InputAdornment position="start">                                                
                                                <BSSText
                                                    name={`operatore`} 
                                                    label={__t("")}    
                                                    methods={methods}          
                                                    TextFieldInputProps={{
                                                        sx: {
                                                            paddingRight: 0
                                                        }
                                                    }}
                                                    TextFieldProps={{
                                                        variant: "standard",
                                                        select: true,    
                                                        SelectProps: {
                                                            native: true
                                                        }, 
                                                        children: Object.entries(mappaOperatoriComparazione).map(([value, label], indiceOp) => {
                                                            return (
                                                                <option key={indiceOp} value={value}>{" "}{label}</option>
                                                            )
                                                        })
                                                    }}
                                                    
                                                />
                                            </InputAdornment>
                                        )
                                    }
                                }}
                                ControllerProps={{rules}}
                            />
                            
                        </Box>
                        <Divider />
                        <Box p={2} sx={{textAlign: "right"}}>
                            <Button variant={"contained"} type={"submit"}>
                                {__t("filtra")}
                            </Button>
                        </Box>
                    </Stack>
                    
                </BSSForm>
            </FormProvider>

        </BSSDialogWithActions>
    )
}

export default DialogFiltroTotale;